<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [title]="chartOptions.title!"
        [colors]="chartOptions.colors!"
        [legend]="chartOptions.legend!"
        [tooltip]="chartOptions.tooltip!"
        [grid]="chartOptions.grid!"
    ></apx-chart>
</div>